import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AlertRuleViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  alertTypeValue?: { displayId: string; id: string } | null;
  alertType: string;
  enabledValue?: { displayId: string; id: string } | null;
  enabled: boolean;
  paramsValue?: { displayId: string; id: string } | null;
  params: string;
};

export const AlertRuleViewForm: React.FC<AlertRuleViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    alertType = "",
    enabled = false,
    params = "{}",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupAlertRuleLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={alertType}
                label={langStore.AlertRuleAlertTypeLabel}
              />
              <ShowBoolean
                value={enabled}
                label={langStore.AlertRuleEnabledLabel}
              />
              <InputCodeEditor
                value={params}
                onChange={() => {}}
                label={langStore.AlertRuleParamsLabel}
                language="json"
                readOnly={true}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
